//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TbmEntry_BASIC from './M_TbmEntry_BASIC';
import { useDispatch, useSelector } from 'react-redux';
import useFileUpload from '../../../../Hooks/useFileUpload';
import { CommonActions } from '../../../../Reducer/CommonReducer';
// useBackStack 임포트
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useTbmSessionSave } from '../hook/useSaveTbmSession';
import dayjs from 'dayjs';
//#endregion

const MAX_PHOTOS = 1;

function M_TbmEntry_BASICF(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { sessionData, stepData, meetFlag } = useSelector((state) => state.tbm);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  const [inputs, setInputs] = useState({
    tbmTitle: '',
    tbmContent: '',
    tbmAddress: '',
    photoNm: '',
    photoImg: null,
    photoSrc: '',
  });

  const tbmUpload = useFileUpload({
    oldFilePathField: 'entryPath',
    newFileNameField: 'saveName',
    getTargetPath: () => `TBM/${sessionData.sessionCd}/Photo`,
    maxCount: MAX_PHOTOS,
  });
  //#endregion

  //#region 커스텀훅
  // 뒤로가기 핸들러 수정
  useBackStack({
    type: 'custom',
    enabled: activeStep > 0,
    onBack: () => {
      tbmUpload.clearFiles();
      setInputs((prev) => ({
        ...prev,
        photoNm: '',
        photoSrc: '',
        photoImg: null,
      }));
      const rollbackStep = meetFlag ? 1 : 2;
      dispatch(CommonActions.setActiveStep(activeStep - rollbackStep));
      !meetFlag &&
        props.ActiveButton({
          type: 'end',
          content: true,
          waiting: 'N',
        });
    },
  });
  const { SaveTbmSession } = useTbmSessionSave({
    fileSave: async () => {
      const finalPath = await tbmUpload.SaveLogicFile();
      return { entryPath: finalPath };
    },
  });
  //#endregion

  //#region 이펙트
  const Init = async () => {
    try {
      SaveTbmSession([
        {
          ...sessionData,
          curStepOrder: stepData.find((f) => f.stepCode === props.stepCode)
            ?.stepOrder,
          curStepCode: stepData.find((f) => f.stepCode === props.stepCode)
            ?.stepCode,
          curPosition: stepData.find((f) => f.stepCode === props.stepCode)
            ?.lastPosition,
        },
      ]);
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          open: true,
          message: e.message,
          type: 'error',
        })
      );
    }
  };
  useEffect(() => {
    Init();
    return () => {
      tbmUpload.clearFiles();
    };
  }, []);
  useEffect(() => {
    const list = (tbmUpload.previewList ?? []).filter((img) => !img.deleted);
    setInputs((prev) => {
      if (list.length === 0) {
        return { ...prev, photoNm: '', photoSrc: '', photoImg: null };
      }
      const first = list[0];
      return {
        ...prev,
        photoNm: first.fileName || '',
        photoSrc: first.preview || '',
        photoImg: null,
      };
    });
  }, [tbmUpload.previewList]);
  //#endregion

  //#region 저장
  const SaveLogic1 = async () => {
    if (!inputs.tbmTitle || !inputs.tbmAddress || !inputs.tbmContent) {
      dispatch(
        showSnackbar({
          message: '제목, 장소, 내용을 입력해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    const end = dayjs();
    const endDt = end.format('YYYY-MM-DD HH:mm:ss');
    const startMs = dayjs(
      String(sessionData.startDt).replace(' ', 'T')
    ).valueOf();
    const totalElapsedTime = Math.max(
      0,
      Math.floor((end.valueOf() - startMs) / 1000)
    );

    await SaveTbmSession([
      {
        ...sessionData,
        sessionStatus: 'CLOSE',
        tbmDate: dayjs().format('YYYY-MM-DD'),
        tbmTitle: inputs.tbmTitle,
        tbmContent: inputs.tbmContent,
        tbmAddress: inputs.tbmAddress,
        endDt,
        totalElapsedTime,
      },
    ]);

    dispatch(CommonActions.setActiveStep(activeStep + 1));
    props.ActiveButton({
      type: 'stepChange',
      step: activeStep + 1,
    });
    props.ActiveButton({
      type: 'end',
      content: true,
      waiting: 'N',
    });

    tbmUpload.clearFiles();
  };
  //#endregion

  return (
    <M_TbmEntry_BASIC
      MAX_PHOTOS={MAX_PHOTOS}
      inputs={inputs}
      setInputs={setInputs}
      tbmUpload={tbmUpload}
      SaveLogic1={SaveLogic1}
      ActiveButton={props.ActiveButton}
      userInfo={userInfo}
    />
  );
}

export default M_TbmEntry_BASICF;
